import {Icon} from "../../../components/common/FontIcon";
import {useAppSelector} from "../../../redux/hooks";
import {lessonPlayerStore} from "../../../redux/lesson/LessonPlayerStore";

export interface ISpeedSelectorIconLogic {
  tempoIcon: Icon;
}

function getIsTempoNormal(currentlySelectedSpeed: number) {
  if (currentlySelectedSpeed === 1) {
    return `icon-tempo`
  }

  return `icon-tempo-solid`
}

export const useSpeedSelectorIconLogic = (): ISpeedSelectorIconLogic => {
  const currentSpeed: number = useAppSelector(lessonPlayerStore.getSpeed);

  return {
    tempoIcon: getIsTempoNormal(currentSpeed)
  };
}
